import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaNivel(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [postCargo, setPostCargo] = useState("");
  const [postNombre, setPostNombre] = useState("");
  const [postProfesion, setPostProfesion] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaNivelDirectivo",
        data: {
          Cargo: postCargo,
          Nombre: postNombre,
          Profesion: postProfesion,
          SolicitudId: props.idSolicitud,
        },
      });

      // 🔹 AGREGA A LA TABLA SIN RECARGAR
      props.onRegistroCreado({
        id: response.data?.id,
        cargo: postCargo,
        nombre: postNombre,
        profesion: postProfesion,
        solicitudId: props.idSolicitud,
      });

      alert("Añadido con éxito");
      setPostCargo("");
      setPostNombre("");
      setPostProfesion("");
      setIsOpen(false);
    } catch (error) {
      console.error(error);
      alert("Error al crear el registro");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-primary btn-lg mb-3"
        onClick={() => setIsOpen(true)}
      >
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Crear Nivel Directivo
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Cargo"
                  value={postCargo}
                  onChange={(e) => setPostCargo(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Nombre"
                  value={postNombre}
                  onChange={(e) => setPostNombre(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Profesión"
                  value={postProfesion}
                  onChange={(e) => setPostProfesion(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading ? "Guardando..." : "Guardar"}
              </button>
            </form>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaNivel;
